import { Component, OnInit, ElementRef, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import { CommonService } from 'src/app/shared/service/common.service';
import { UtilService } from 'src/app/core/services/util.service'; // adjust path to match your project
import { AuthenticationService } from 'src/app/shared/service/authentication.service';
import { COMMON_SVG_IMG_PATH } from 'src/app/shared/common.constant';
import { logout, updateSelectedVehicle } from 'src/app/store/user/user.actions';
import {
  selectSelectedVehicle,
  selectVehicleTypes,
} from 'src/app/store/user/user.selectors';
import { LoadUserMenuList } from 'src/app/store/userMenuList/userMenuList.action';
import { VEHICLE_IMG } from '../sidenav/nav-data'; // adjust relative path
import {
  VehicleTypeCode,
  VehicleType,
  Vehicles,
} from '../sidenav/sidenav.interface'; // adjust relative path

@Component({
  selector: 'app-vehicle-switcher',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './vehicle-switcher.component.html',
  styleUrls: ['./vehicle-switcher.component.scss'],
})
export class VehicleSwitcherComponent implements OnInit {
  vehicleType: VehicleType[] = [];
  allVehicles: Vehicles[] = [];
  filteredVehicles: Vehicles[] = [];
  selectedVehicleObj: any;
  isOpen = false;
  svgPath: string = COMMON_SVG_IMG_PATH;

  constructor(
    private readonly store: Store,
    private readonly commonService: CommonService,
    private readonly utilService: UtilService,
    private readonly authenticationService: AuthenticationService,
    private readonly elRef: ElementRef
  ) {}

  ngOnInit(): void {
    this.store.select(selectVehicleTypes).subscribe((vehicleTypes) => {
      this.vehicleType = vehicleTypes ?? [];
      this.allVehicles = this.vehicleType.map((v: any) => ({
        ...v,
        icon: this.resolveIcon(v),
      }));
      this.updateFilteredVehicles();
    });

    this.store.select(selectSelectedVehicle).subscribe((vehicle) => {
      this.selectedVehicleObj = vehicle || this.vehicleType[0];
      this.updateFilteredVehicles();
    });
  }

  private resolveIcon(vehicle: any): string {
    const idx: any = VehicleTypeCode[vehicle.code];
    return VEHICLE_IMG[idx];
  }

  iconExtension(): string {
    return `${this.svgPath}${this.selectedVehicleObj?.name}.svg`;
  }

  private updateFilteredVehicles(): void {
    this.filteredVehicles = this.allVehicles.filter(
      (v) => v.name !== this.selectedVehicleObj?.name
    );
  }

  toggle(): void {
    if (this.filteredVehicles.length === 0) {
      return; // nothing to switch to — don't open an empty dropdown
    }
    this.isOpen = !this.isOpen;
  }

  // Closes the dropdown when clicking anywhere outside this component
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.isOpen) return;
    if (!this.elRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }

  // Separate method so tests can replace the full page reload.
  protected reloadPage(): void {
    window.location.reload();
  }

  selectVehicle(vehicle: Vehicles): void {
    this.isOpen = false;

    if (this.selectedVehicleObj?.name === vehicle.name) {
      return;
    }

    this.selectedVehicleObj = vehicle;
    this.updateFilteredVehicles();

    this.store.dispatch(
      updateSelectedVehicle({
        vehicle: { name: vehicle.name, code: vehicle.code, id: vehicle.id },
      })
    );

    this.utilService.loadMenuLinks(vehicle.code).subscribe({
      next: (navData: any) => {
        this.store.dispatch(LoadUserMenuList({ menu: navData }));
        this.reloadPage(); // matches existing sidenav behavior on LOB switch
      },
      error: () => {
        this.utilService.logoutApi().subscribe(() => {
          this.commonService.clearLocalStorageItems();
          this.store.dispatch(logout());
          sessionStorage.clear();
          this.utilService.redirectToLogin();
        });
      },
    });
  }
}
